import React from 'react';
import { EditorState, Modifier } from 'draft-js';
import { Button, Stack } from '@mui/material';
const ButtonAddtag = ({ editeState, setEditeState }) => {
  const methos = {
    addVariable: (item) => {
      const newContentState = Modifier.replaceText(
        editeState.getCurrentContent(),
        editeState.getSelection(),
        item,
        editeState.getCurrentInlineStyle(),
      );
      const newEditorState = EditorState.push(
        editeState,
        newContentState,
        'insert-characters',
      );
      setEditeState(newEditorState);
    },
  };
  return (
    <div>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        useFlexGap
        flexWrap="wrap"
        spacing={1}
      >
        <Button
          variant="outlined"
          sx={{ width: 200 }}
          onClick={() => methos.addVariable('${so_name}')}
        >
          ชื่อลูกหนี้
        </Button>
        <Button
          variant="outlined"
          sx={{ width: 200 }}
          onClick={() => methos.addVariable('${invoice_no}')}
        >
          เลขที่ใบแจ้งหนี้
        </Button>
        <Button
          variant="outlined"
          sx={{ width: 200 }}
          onClick={() => methos.addVariable('${link_payment}')}
        >
          ลิงค์การชำระเงิน
        </Button>
        <Button
          variant="outlined"
          sx={{ width: 200 }}
          onClick={() => methos.addVariable('${qr_payment}')}
        >
          QR การชำระเงิน
        </Button>
      </Stack>
    </div>
  );
};

export default ButtonAddtag;
